import { ROUTE_SEGMENTS } from './route-segments';
var abs = function (segment) { return (segment.startsWith('/') ? segment : "/".concat(segment)); };
export var ROUTES = {
    HOME: abs(ROUTE_SEGMENTS.HOME),
    CHATS: abs(ROUTE_SEGMENTS.CHATS),
    SHOP: abs(ROUTE_SEGMENTS.SHOP),
    CAFETERIA_BENEFITS: abs(ROUTE_SEGMENTS.CAFETERIA_BENEFITS),
    INCOME_TEAL: abs(ROUTE_SEGMENTS.INCOME_TEAL),
    PROFILE: abs(ROUTE_SEGMENTS.PROFILE),
    SETTINGS_PROFILE: abs(ROUTE_SEGMENTS.SETTINGS_PROFILE),
    ADDRESS_BOOK: abs(ROUTE_SEGMENTS.ADDRESS_BOOK),
    ORGANIZATION_STRUCTURE: abs(ROUTE_SEGMENTS.ORGANIZATION_STRUCTURE),
    MY_DEVELOPMENT: abs(ROUTE_SEGMENTS.MY_DEVELOPMENT),
    MY_EMPLOYEES_DEVELOPMENT: abs(ROUTE_SEGMENTS.MY_EMPLOYEES_DEVELOPMENT),
    AWARDS: abs(ROUTE_SEGMENTS.AWARDS),
    RATINGS: abs(ROUTE_SEGMENTS.RATINGS),
    SURPRISE_BOXES: abs(ROUTE_SEGMENTS.SURPRISE_BOXES),
    CREATE_ONE_TO_ONE: abs(ROUTE_SEGMENTS.CREATE_ONE_TO_ONE),
    SUPERVISOR_APPLICATIONS: abs(ROUTE_SEGMENTS.SUPERVISOR_APPLICATIONS),
    EMPLOYEES: abs(ROUTE_SEGMENTS.EMPLOYEES),
    APPLICATIONS: abs(ROUTE_SEGMENTS.APPLICATIONS),
    SETTINGS: abs(ROUTE_SEGMENTS.SETTINGS),
    CREATE_EMISSION: abs(ROUTE_SEGMENTS.CREATE_EMISSION),
    ORDERS: abs(ROUTE_SEGMENTS.ORDERS),
    ACTIVITIES: abs(ROUTE_SEGMENTS.ACTIVITIES),
    PRODUCTS: abs(ROUTE_SEGMENTS.PRODUCTS),
    CREATE_PRODUCT: abs(ROUTE_SEGMENTS.CREATE_PRODUCT),
    CREATE_AWARD: abs(ROUTE_SEGMENTS.CREATE_AWARD),
    SURPRISE_BOXES_CREATE: abs(ROUTE_SEGMENTS.SURPRISE_BOXES_CREATE),
    SURVEYS: abs(ROUTE_SEGMENTS.SURVEYS),
    SELECT_SURVEY_TYPE: abs(ROUTE_SEGMENTS.SELECT_SURVEY_TYPE),
    CREATE_SURVEY: abs(ROUTE_SEGMENTS.CREATE_SURVEY),
    SUPPORT_REQUESTS: abs(ROUTE_SEGMENTS.SUPPORT_REQUESTS),
    STATISTICS: abs(ROUTE_SEGMENTS.STATISTICS),
    TEAM_STATISTICS: abs(ROUTE_SEGMENTS.TEAM_STATISTICS),
    CORPORATE_CURRENCY_STATISTICS: abs(ROUTE_SEGMENTS.CORPORATE_CURRENCY_STATISTICS),
    ACTIVITIES_STATISTICS: abs(ROUTE_SEGMENTS.ACTIVITIES_STATISTICS),
    SURVEYS_STATISTICS: abs(ROUTE_SEGMENTS.SURVEYS_STATISTICS),
    REWARDS_STATISTICS: abs(ROUTE_SEGMENTS.REWARDS_STATISTICS),
    GRATITUDES_STATISTICS: abs(ROUTE_SEGMENTS.GRATITUDES_STATISTICS),
    POST_CREATE: abs(ROUTE_SEGMENTS.POST_CREATE),
    USERS: abs(ROUTE_SEGMENTS.USERS),
    BENEFIT_ADMIN: abs(ROUTE_SEGMENTS.BENEFIT_ADMIN),
    REGISTRATION: abs(ROUTE_SEGMENTS.REGISTRATION),
    PREVIEW_SURVEY: abs(ROUTE_SEGMENTS.PREVIEW_SURVEY),
    DOCS: abs(ROUTE_SEGMENTS.DOCS),
    CONFIDENTIAL: abs(ROUTE_SEGMENTS.CONFIDENTIAL),
    COOKIES: abs(ROUTE_SEGMENTS.COOKIES),
    POLICY: abs(ROUTE_SEGMENTS.POLICY),
    COMPLIANCE: abs(ROUTE_SEGMENTS.COMPLIANCE),
    addressBookEmployee: function (userId) { return "".concat(abs(ROUTE_SEGMENTS.ADDRESS_BOOK), "/").concat(userId); },
    takeSurvey: function (surveyId) { return "/take-survey/".concat(surveyId); },
    award: function (awardId) { return "/award/".concat(awardId); },
    surpriseBox: function (id) { return "/surprise-boxes/".concat(id); },
    editOneToOne: function (id) { return "/edit-one-to-one/".concat(id); },
    post: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/post/".concat(postId).concat(suffix);
    },
    awardPost: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/award-post/".concat(postId).concat(suffix);
    },
    activityAnnouncementPost: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/activity-announcement-post/".concat(postId).concat(suffix);
    },
    leaderPost: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/leader-post/".concat(postId).concat(suffix);
    },
    birthdayPost: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/birthday-post/".concat(postId).concat(suffix);
    },
    recognitionPost: function (recognitionPostId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/recognition-post/".concat(recognitionPostId).concat(suffix);
    },
    recognitionSupervisorPost: function (recognitionPostId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/recognition-supervisor-post/".concat(recognitionPostId).concat(suffix);
    },
    surveyPost: function (postId, suffix) {
        if (suffix === void 0) { suffix = ''; }
        return "/survey-post/".concat(postId).concat(suffix);
    },
    chat: function (chatId) { return "/chat/".concat(chatId); },
    editEmployee: function (userId) { return "/edit/employee/".concat(userId); },
    editEmission: function (emissionId) { return "/edit-emission/".concat(emissionId); },
    editProduct: function (productId) { return "/edit-product/".concat(productId); },
    editCafeteriaBenefits: function (benefitId) { return "/edit-cafeteria-benefits/".concat(benefitId); },
    surpriseBoxesEdit: function (id) { return "/surprise-boxes/edit/".concat(id); },
    editAward: function (awardId) { return "/edit-award/".concat(awardId); },
    editSurvey: function (surveyId) { return "/edit-survey/".concat(surveyId); },
    surveyResults: function (surveyId) { return "/survey-results/".concat(surveyId); },
    enpsSurveyResults: function (surveyId) { return "/enps-survey-results/".concat(surveyId); },
    supportRequest: function (requestId) { return "/support-request/".concat(requestId); },
    postEdit: function (postId) { return "/post/edit/".concat(postId); },
    registrationCompany: function (companyId) { return "/registration/".concat(companyId); },
    hrClubRegistration: function (companyId) { return "/hr-club-registration/".concat(companyId); },
    takeSurveyLinkAccess: function (surveyId) { return "/take-survey/link-access/".concat(surveyId); },
};
